import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import { LOAD_ADDRESS_SUCCESS } from '../../../actions/jobsite-actions/jobsite.actions';
import { RenderMapAction } from '../../../actions/location-map-actions/location-map.actions';
import { CmxMapConfig } from '../../../../../../shared/models/cmx-map-config/cmx-map-config';
import { OrderBuilderState, getJobsiteState } from '@ordersnproducts/modules/order-builder/reducers';
import { MAP_ADDRESS_TYPES } from '@ordersnproducts/modules/shared/constants/map-address-types';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { UnicEffectsAvailableEnum } from '@ordersnproducts/modules/shared/modules/dynamic-effects/deletable-effect-sources.constant';
import { EffectsRegistrationService } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effects-registration.service';

@Injectable()
export class JobsiteRadiusRenderMapEffects implements IEffect {
  /**
   * Render location map action
   * @type {Observable<RenderMapAction>}
   */

  JobsiteRadiuesLoadAddressComplete$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_ADDRESS_SUCCESS),
      filter(() => this.isEffectAvailable()),
      withLatestFrom(this.store.select(getJobsiteState)),
      switchMap(([payload, jobsiteState]: any) => {
        const jobsiteSelected = _safe(() => jobsiteState.selected, undefined);
        return of(
          new RenderMapAction(
            new CmxMapConfig(
              payload.payload,
              MAP_ADDRESS_TYPES.JOBSITE,
              jobsiteSelected && jobsiteSelected.isVariousLocation ? jobsiteState.realJobsiteAddress : undefined,
              jobsiteSelected && jobsiteSelected.isVariousLocation ? jobsiteSelected.distance : undefined,
            ),
          ),
        );
      }),
    ),
  );

  private isEffectAvailable(): boolean {
    return this.effectRegister.isEffectAvailable(UnicEffectsAvailableEnum.JobsiteRadiusRenderMapEffects);
  }

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private effectRegister: EffectsRegistrationService,
  ) {}
}
